// @ts-nocheck
(function () {
  const SITE_KEY = "6LeQ9ZwtAAAAANUW0JYb0U6xN438RJmRw2aob-Xu";
  const SRC =
    "https://www.google.com/recaptcha/api.js?onload=__miloRecaptchaOnload&render=explicit";

  let loadPromise = null;
  const readyQueue = [];

  window.__miloRecaptchaOnload = function () {
    while (readyQueue.length) {
      readyQueue.shift()();
    }
  };

  function ensureLoaded() {
    if (loadPromise) return loadPromise;
    loadPromise = new Promise((resolve, reject) => {
      if (window.grecaptcha && window.grecaptcha.render) {
        resolve();
        return;
      }
      readyQueue.push(resolve);
      const script = document.createElement("script");
      script.src = SRC;
      script.async = true;
      script.defer = true;
      script.onerror = () => reject(new Error("Failed to load reCAPTCHA"));
      document.head.appendChild(script);
    });
    return loadPromise;
  }

  async function render(container, options) {
    await ensureLoaded();
    return window.grecaptcha.render(container, {
      sitekey: SITE_KEY,
      ...(options || {}),
    });
  }

  function getResponse(widgetId) {
    if (!window.grecaptcha || typeof widgetId !== "number") return "";
    return window.grecaptcha.getResponse(widgetId);
  }

  function reset(widgetId) {
    if (!window.grecaptcha || typeof widgetId !== "number") return;
    window.grecaptcha.reset(widgetId);
  }

  window.miloRecaptcha = { render, getResponse, reset, siteKey: SITE_KEY };
})();
